module.exports = __webpack_public_path__ + "media/svg-new/config-1f7dcef3.svg";